<div class="fullscreen-loading" role="status" aria-live="polite">
  <img
    class="fullscreen-loading__logo"
    src="assets/images/logotype/openapp-logotype-color.webp"
    alt="OpenApp"
    width="180"
    height="31"
    loading="eager"
    decoding="async"
  />

  <div class="fullscreen-loading__dots" aria-hidden="true">
    <span class="fullscreen-loading__dot"></span>
    <span class="fullscreen-loading__dot"></span>
    <span class="fullscreen-loading__dot"></span>
    <span class="fullscreen-loading__dot"></span>
  </div>

  <span class="visually-hidden">Loading</span>
</div>
